import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing059({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "c0c43066-b359-42cb-a29e-25a7509a850a", label: "프리미엄 정밀검진" },
    { value: "0a385bc8-bb6b-473e-8441-e8404ca7433e", label: "수험생 이벤트" },
  ];
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/059/25010601.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/059/25010602.jpg`}
      benefitInfoPosition="top"
      formFieldColor="white"
      adTarget="맘카페 이용자"
      periodType="month"
      // privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/applyBenefitButton.png`}
      companyName="본원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan2.jpg`}
      treatments={treatments}
    />
  );
}

export default Randing059;
